/**
 * Converts an arbitrary string (e.g. a CSV column header) to a valid api_name
 * that satisfies the regex /^[a-z][a-z0-9_]*$/.
 *
 * Rules:
 *  1. Lowercase the whole string.
 *  2. Replace every run of non-alphanumeric characters with a single underscore.
 *  3. Trim leading/trailing underscores.
 *  4. If the result is empty, return "col".
 *  5. If the result starts with a digit, prefix with "col_".
 *
 * Examples:
 *   "Transaction ID"  → "transaction_id"
 *   "Source System"   → "source_system"
 *   "2024 Total"      → "col_2024_total"
 *   "  __foo__  "     → "foo"
 *   "123"             → "col_123"
 *   ""                → "col"
 */
export function toApiName(s: string): string {
  const slugged = s
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "_")
    .replace(/^_+|_+$/g, "");

  if (slugged === "") return "col";
  if (/^[0-9]/.test(slugged)) return `col_${slugged}`;
  return slugged;
}

/**
 * Returns true if `header` (after slugifying) matches the given `apiName`.
 * Used for case/space-insensitive auto-inference in the mapping wizard.
 */
export function headerMatchesApiName(header: string, apiName: string): boolean {
  return toApiName(header) === apiName;
}
